// SavedRecipes.js
import { collection, getDocs, query, where } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import RecipeCard from './Recipe-card';
import { fetchSavedRecipes } from './api';
import { auth, db } from './firebase';
import Heading1 from './headings/Heading1';

function SavedRecipes() {
    const [savedRecipes, setSavedRecipes] = useState([]);
    const [user] = useAuthState(auth);

    const fetchUserDocumentId = async (userUID) => {
        if (user) {
            const usersCollection = collection(db, 'users');
            const userQuery = query(usersCollection, where('uid', '==', userUID));
            const querySnapshot = await getDocs(userQuery);
            if (!querySnapshot.empty) {
                const userDocumentId = querySnapshot.docs[0].id;
                return userDocumentId;
            }
            return null;
        } else {
            return null;
        }
    };

    useEffect(() => {
        if (user) {
            fetchUserDocumentId(user.uid)
                .then((userDocumentId) => {
                    return fetchSavedRecipes(userDocumentId);
                })
                .then((savedRecipes) => {
                    setSavedRecipes(savedRecipes);
                });
        } else {
            return setSavedRecipes([]);
        }
    }, [user]);

    return (
        <div className="w-full py-12 px-4 sm:px-6 lg:px-8 bg-gray-50 min-h-screen">
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="mb-8">
                    <Heading1 title="Saved Recipes" />
                </div>

                {/* Recipes Grid */}
                {savedRecipes.length > 0 ? (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {savedRecipes.map((recipe, index) => (
                            <div key={recipe.id || index} className="flex justify-center">
                                <RecipeCard recipe={recipe} />
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-16">
                        <div className="text-6xl mb-4">❤️</div>
                        <h3 className="text-2xl font-bold text-gray-700 mb-2">No saved recipes yet</h3>
                        <p className="text-gray-500 mb-6">Start saving your favorite recipes!</p>
                        <button
                            className="px-6 py-3 bg-gradient-to-r from-pink-600 to-purple-600 text-white font-bold rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
                            onClick={() => { window.location = '/' }}
                        >
                            Discover Recipes
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default SavedRecipes;
